import { getApiBaseUrl, getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();

export async function getPurchaseInvoiceNumber(cookies, plant_id, invoice_date) {
  const url = `${apiBaseUrl}/purchase_invoices/invoice_number/?plant_id=${plant_id}&invoice_date=${invoice_date}`;
  return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getGrnsForPurchaseInvoice(cookies, plantId, vendorId, invoiceId) {
  const params = new URLSearchParams({
    plant_id: plantId,
    vendor_id: vendorId,
  });
  if (invoiceId) {
    params.append('invoice_id', invoiceId);
  }
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/purchase_invoices/grns_for_invoice/?${params.toString()}`)
    .then((response) => response.data);
}

export async function getAllPurchaseInvoices(cookies, params = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/purchase_invoices/`, { params })
    .then((response) => response.data);
}

export function createPurchaseInvoice(cookies, inputs) {
  return getApiClient(cookies).post(`${apiBaseUrl}/purchase_invoices/`, inputs);
}

export function updatePurchaseInvoice(cookies, invoiceId, inputs) {
  return getApiClient(cookies).put(`${apiBaseUrl}/purchase_invoices/${invoiceId}/`, inputs);
}

export async function getPurchaseInvoiceDetails(cookies, invoiceId) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/purchase_invoices/${invoiceId}/`)
    .then((response) => response.data);
}

export function deletePurchaseInvoice(cookies, invoiceId) {
  return getApiClient(cookies).delete(`${apiBaseUrl}/purchase_invoices/${invoiceId}/`);
}

export function uploadPurchaseInvoiceDocument(cookies, invoiceId, docType, file) {
  const formData = new FormData();
  formData.append('doc_type', docType);
  formData.append('file', file);
  return getApiClient(cookies).post(
    `${apiBaseUrl}/purchase_invoices/${invoiceId}/documents/`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 },
  ).then((response) => response.data);
}

export function deletePurchaseInvoiceDocument(cookies, invoiceId, docId) {
  return getApiClient(cookies).delete(
    `${apiBaseUrl}/purchase_invoices/${invoiceId}/documents/${docId}/`,
  );
}

export async function uploadPendingPurchaseInvoiceDocuments(cookies, invoiceId, pendingDocs) {
  const uploaded = [];
  for (const doc of pendingDocs || []) {
    if (doc && doc.file) {
      uploaded.push(await uploadPurchaseInvoiceDocument(cookies, invoiceId, doc.doc_type, doc.file));
    }
  }
  return uploaded;
}

// legacy aliases used by old table stub
export const getAllPurchaseInvoice = getAllPurchaseInvoices;
